import { useQuery } from '@tanstack/react-query';

import type { QueryFunction } from '@frontend/api';
import { useRequest } from '@frontend/api';

import type { OrdersOverviewQueryKeyType } from './getOrdersOverviewQueryKey';
import { getOrdersOverviewQueryKey } from './getOrdersOverviewQueryKey';
import type {
  OrdersOverviewQueryParams,
  OrdersOverviewResponse,
} from './types';

export const useGetOrdersOverview: QueryFunction<
  OrdersOverviewResponse,
  [],
  OrdersOverviewQueryKeyType,
  OrdersOverviewQueryParams
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    keepPreviousData: true,
    ...queryOptions,
    queryKey: getOrdersOverviewQueryKey(query),
    queryFn: ({ signal }) =>
      request('/orders/overview', {
        query,
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
